import React from 'react';
interface DropDownMenuProps extends React.PropsWithChildren<{}> {
    menuItems?: React.ReactNode;
}

interface DropDownMenuState {
    actionVisible: boolean;
}

class DropDownMenu extends React.Component<DropDownMenuProps, DropDownMenuState> {

    constructor(props: DropDownMenuProps) {
        super(props);

        this.state = {
            actionVisible: false
        };
    }

    private _toggleActionVisible = () => {
        var visible = !this.state.actionVisible;
        this.setState({
            actionVisible: !this.state.actionVisible
        });

        if (visible) {
            setTimeout(() => { window.addEventListener('click', this._closeToggle) }, 50);
        }
    }

    private _closeToggle = () => {
        this.setState({
            actionVisible: false
        });

        window.removeEventListener('click', this._closeToggle);
    }

    render() {
        return (
            <div className="drop-down-menu-container" onClick={this._toggleActionVisible}>
                { this.props.children }
                <ul className={`drop-down-menu ${this.state.actionVisible ? 'is-visible' : ''}`}>
                    { this.props.menuItems }
                </ul>
            </div>
        );
    }
};

export default DropDownMenu;